// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\PackageResponse

import { hydratePackageComposition, type PackageComposition, type PackageCompositionApiResponse } from './packageComposition.gen';
import { DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type PackageApiResponse = {
	id: string;
	title: string;
	color: string;
	textColor: string;
	backgroundOverlayDisplay: boolean;
	logo: string | null;
	backgroundImage: string | null;
	description: string;
	price: number;
	publishStart: string | null;
	publishEnd: string | null;
	limitPerCustomer: number | null;
	usageLimit: number | null;
	maxQuantityPerBooking: number | null;
	validityDays: number | null;
	validityDates: string[] | null;
	compositions: PackageCompositionApiResponse[];
	createdAt: string;
	updatedAt: string;
	archivedAt: string | null;
};

export type Package = {
	id: string;
	title: string;
	color: string;
	textColor: string;
	backgroundOverlayDisplay: boolean;
	logo: string | null;
	backgroundImage: string | null;
	description: string;
	price: number;
	publishStart: DateTime | null;
	publishEnd: DateTime | null;
	limitPerCustomer: number | null;
	usageLimit: number | null;
	maxQuantityPerBooking: number | null;
	validityDays: number | null;
	validityDates: string[] | null;
	compositions: PackageComposition[];
	createdAt: DateTime;
	updatedAt: DateTime;
	archivedAt: DateTime | null;
};

export function hydratePackage(data: PackageApiResponse): Package {
	return {
		...data,
		publishStart: DateTimefromISO(data.publishStart),
		publishEnd: DateTimefromISO(data.publishEnd),
		compositions: data.compositions.map(hydratePackageComposition),
		createdAt: DateTimefromISO(data.createdAt)!,
		updatedAt: DateTimefromISO(data.updatedAt)!,
		archivedAt: DateTimefromISO(data.archivedAt),
	};
}